import { GetPurchase } from "../../../WorkSpace/Components/ApiServices/apiHandler";

export const fetchAllPurchase = (search = "") => {
    return dispatch => {
        dispatch({type:"PURCHASE_ACTION_START"})
        GetPurchase(search).then((result)=>{
            dispatch({
                type: "PURCHASE_FETCH_DATA",
                payload: result.data.purchases || result.data.Purchase || []
            }) 
        }).catch((error)=>{
            dispatch({
                type: "PURCHASE_FETCH_DATA_FAILED",
                payload: error.response?.data?.error
            }) 
        });
    }
}
